/**
 * When Word Sprout is open (New York time).
 *
 * The database sleeps outside these hours to keep the bill near zero (about
 * $9 a month awake all the time, against cents for these windows). Cloud
 * Scheduler wakes it ten minutes early and puts it back to sleep after; the
 * exact commands are in research/gcp-setup.md section 28. If they change,
 * change this list too: it is what a child reads when the app is asleep.
 *
 *   Monday to Friday       7:00 to 8:35 in the morning   (Sam, 5 Oct; ends 8:35 from 31 Oct 2026)
 *   Tuesday and Thursday   4:25 to 5:15 in the afternoon (Sam, 8 to 20 Oct; ends 5:15 from 31 Oct 2026)
 *   Saturday and Sunday    7:30 to 10:30 in the morning  (Sam, 18 Oct; ends 10:30 from 31 Oct 2026)
 */
export const PRACTICE_HOURS: { days: string; time: string }[] = [
  { days: 'Monday to Friday', time: '7:00 to 8:35 in the morning' },
  { days: 'Tuesday and Thursday', time: '4:25 to 5:15 in the afternoon' },
  { days: 'Saturday and Sunday', time: '7:30 to 10:30 in the morning' },
]

export const HOURS_ZONE = 'New York time'
